import React, { memo } from 'react';

import * as Typed from './ColorList.typed';
import styles from './ColorList.module.css';

const ColorList = memo<Typed.Props>(({ colorsArr, onChangeColor }) => {
  const list = colorsArr.map(({ id, code, rgb, isLight }) => {
    const { r, g, b } = rgb;

    return (
      <div
        className={styles['colors-item']}
        key={id}
        onClick={() => onChangeColor(rgb, code, id)}
        style={{
          backgroundColor: `rgb(${r}, ${g}, ${b})`,
        }}
      >
        <div
          style={{
            color: isLight ? 'black' : '#FAFAFA',
          }}
        >
          {code}
        </div>
      </div>
    );
  });

  return <>{list}</>;
});

export { ColorList, Typed as ColorListTyped };
